
import {useContext, useState} from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import OrderCard from './OrderCard';

export default function CustomerCard({website, client, inx}) {
    const {primary_color, secondary_color, accent_color} = useContext(AppContext);
    const [showOrdersFlag, setShowOrdersFlag] = useState(false);
    const deployOrdersList=()=>{
        try{
            if(client.orders.length===0 && showOrdersFlag){
                return <h3>עדיין לא בוצעו הזמנות ללקוח זה</h3>
            }
            return client.orders.map((order, inx)=>{
                return <OrderCard key={`orderCard_${client.name}_order_${inx}`} order={order} client={client}/>
            })
        } catch(err){console.error("can't deploy orders",err)}
    }
    return (
        <div key={`clientCard_${inx}`} className='clientCard' style={{backgroundColor:primary_color, color:accent_color}}>
            <p><b>שם הלקוח:</b> {client?.name}</p>
            <div className="clientCard_detailsDiv" style={{backgroundColor:secondary_color, color:primary_color}} dir='rtl' onClick={()=>{setShowOrdersFlag(!showOrdersFlag)}}>
                <p><b>מס' פלאפון:</b> {client?.phone}</p>
                <p><b>מייל:</b> {client?.email}</p>
                <p><b>כתובת:</b> {client?.address!=="" ? client?.address : "לא הוגדרה כתובת"}</p>
            </div>
            {showOrdersFlag && <div className="clientCard_ordersDiv">
                {deployOrdersList()}
            </div>}
        </div>
    )
}
